<mat-card appearance="outlined" *ngIf="isFormLoaded">
<!--  <h3>{{ formLabel }}</h3>-->
<!--  <p>{{ formDescription }}</p>-->

  <formly-form [fields]="fields" [options]="options" [model]="model" [form]="form"></formly-form>

  <button type="button" mat-flat-button color="primary" (click)="addIPN()">Add IPN</button>
</mat-card>
